module.exports = __webpack_public_path__ + "static/media/gamequiz qualidade alta-02.f8857cc1.png";